import { Flex } from "@chakra-ui/layout";
import InputSearch from "components/Input/InputSearch";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  children?: any;
  childrenFlex?: string | number;
  searchMinW?: string | number;
  searchPlaceholder?: string;
}

function HeaderTable({
  onSearch,
  value,
  children,
  childrenFlex = "auto",
  searchMinW = "250px",
  searchPlaceholder = "Procurar",
}: HeaderTableProps) {
  return (
    <Flex flex={1} gridGap={4} flexWrap="wrap">
      <Flex flex={children ? childrenFlex : 1} minW={searchMinW} zIndex={0}>
        <InputSearch
          defaultValue={value}
          onSearch={(v) => onSearch(v)}
          placeholder={searchPlaceholder}
        />
      </Flex>
      {children ? (
        <Flex alignItems="center" flex={1}>
          {children}
        </Flex>
      ) : null}

      {/* <Flex alignItems="center">
        <OutlineButton
          onClick={open}
          size="sm"
          colorScheme="blue"
          variant="outline"
          pos="relative"
        >
          <BsSliders />
          FILTRAR
          {count ? (
            <Flex
              color="white"
              pos="absolute"
              top="-8px"
              right="-8px"
              w="18px"
              h="18px"
              bg="red"
              fontSize="12px"
              rounded="full"
              justifyContent="center"
              alignItems="center"
            >
              {count}
            </Flex>
          ) : null}
        </OutlineButton>
      </Flex> */}
    </Flex>
  );
}

export default HeaderTable;
